var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-page"}},[_c('HomeHero'),_c('div',{staticClass:"flex flex-wrap sm:flex-nowrap sm:flex-row-reverse"},[_c('Statistics'),_c('AboutEESTEC')],1),_c('Partners')],1)}
var staticRenderFns = []

export { render, staticRenderFns }